import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import { BurnerStatisticsProperties, Feature, FeatureNames } from '@vi-iot/client';
import { Observable } from 'rxjs';
import { SUFFIX } from 'src/app/shared/common/units';

@Component({
  selector: 'app-refrigerant-load-classes-details',
  templateUrl: './refrigerant-load-classes-details.component.html',
  styleUrls: ['./refrigerant-load-classes-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefrigerantLoadClassesDetailsComponent implements OnInit {
  @Input() title: string;
  @Input() refrigerantCircuitId: string;

  refrigerantCircuitStatistics$: Observable<Feature<BurnerStatisticsProperties, never>>;

  SUFFIX = SUFFIX;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.refrigerantCircuitStatistics$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.singleCompressorStatisticsLoad(this.refrigerantCircuitId)
    );
  }
}
